module.exports = __webpack_public_path__ + "img/diagnostico.357c6107.png";